import instance from "../../Interceptor/api_instance";
import CheckInTrailerF15 from "../CheckIn/CheckInTrailerF15";
import CheckInTruckF15 from "../CheckIn/CheckInTruckF15";
import { SpinnerOverlay } from "../../Components/LoadingAnimations/SpinnerOverlay";
import {
  populateF15,
  loadPdfTemplate,
} from "../../Components/Utility/PopulateForms";
import { useEffect, useState } from "react";
import { Spinner } from "../../Components/LoadingAnimations/LoadingAnimations";
import { useTranslation } from "react-i18next";
import { ActionResponse } from "../../Components/Modals/ActionResponses";

const PreviewF15 = ({ report, setPreviewModal }) => {
  const [isEnlargeModalOpen, setIsEnlargeModalOpen] = useState(false);
  const [selectedItemImageSrc, setSelectedItemImageSrc] = useState("");
  const [blobUrl, setBlobUrl] = useState("");
  const [imageUrls, setImageUrls] = useState([]);
  const { t } = useTranslation();

  const EnlargedItemModal = () => (
    <>
      <div style={{ zIndex: "7" }} className="enlarged-modal">
        <div className="img-cont">
          <img src={selectedItemImageSrc} alt="Enlarged" />
        </div>

        <div className="btn-cont">
          <button className="close-btn" onClick={handleCloseEnlargeModal}>
            {t("buttons.back")}
          </button>
        </div>
      </div>
    </>
  );
  const handleOpenEnlargeModal = (imgSrc) => {
    setSelectedItemImageSrc(imgSrc);
    setIsEnlargeModalOpen(true);
  };

  const handleCloseEnlargeModal = () => {
    setIsEnlargeModalOpen(false);
  };

  useEffect(() => {
    const fetchPdf = async () => {
      try {
        const pdfFile = "F15-2024.pdf";
        const pdfTemplate = await loadPdfTemplate(pdfFile);
        const filledPdfBytes = await populateF15(pdfTemplate, report);

        // Convert filledPdfBytes to a Blob
        const blob = new Blob([filledPdfBytes], { type: "application/pdf" });

        // Create a Blob URL
        setBlobUrl(URL.createObjectURL(blob));

        return blobUrl;
      } catch (error) {
        window.alert(error);
        setPreviewModal(false);
      }
    };
    fetchPdf();
  }, []);

  useEffect(() => {
    const fetchImages = async () => {
      try {
        const response = await instance.get(
          `assets/get-entry-images/${report.id}`
        );
        setImageUrls(response.data.img_urls);
      } catch (err) {
        setImageUrls([]);
      }
    };
    fetchImages();
  }, []);

  return (
    <>
      {blobUrl ? (
        <div className="page-mask page-mask-animation">
          <div className="white-cont">
            <div>
              <iframe
                style={{ height: "500px" }}
                src={blobUrl}
                title="PDF Preview"
              ></iframe>
            </div>
            <div>
              {imageUrls.length > 0 ? (
                <div className="photo-grid">
                  {imageUrls.map((image, num) => (
                    <div
                      key={num}
                      className="placeholder2"
                      onClick={() => handleOpenEnlargeModal(image)}
                    >
                      <img src={image} alt={`Item ${num + 1}`} />
                    </div>
                  ))}
                </div>
              ) : (
                <div className="no-img-found">
                  <p>{t("general.no-images")}</p>
                </div>
              )}
              {isEnlargeModalOpen && <EnlargedItemModal />}
            </div>
            <div className="full-cont">
              <button
                className="all-btn change-pwd-btn"
                onClick={() => setPreviewModal(false)}
              >
                Close
              </button>
            </div>
          </div>
        </div>
      ) : (
        <SpinnerOverlay />
      )}
    </>
  );
};

const EditF15 = ({ report, setEditModal, english }) => {
  const [currentForm, setCurrentForm] = useState(1);
  const [truckForm, setTruckForm] = useState(report.f15_truck);
  const [trailerForm, setTrailerForm] = useState(report.f15_trailer);
  const [submitRequest, setSubmitRequest] = useState(false);
  const [message, setMessage] = useState(null);
  const [responseModal, setResponseModal] = useState(false);
  const [status, setStatus] = useState(null);

  const nextForm = () => {
    if (trailerForm && currentForm === 1) {
      setCurrentForm(currentForm + 1);
    } else {
      setCurrentForm(3);
    }
  };

  const backForm = () => {
    if (trailerForm && currentForm === 3) {
      setCurrentForm(currentForm - 1);
    } else {
      setCurrentForm(1);
    }
  };

  const close = () => {
    setEditModal(false);
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      setSubmitRequest(true);
      const data = {
        ...report,
        f15_truck: {
          ...truckForm,
        },
        f15_trailer: {
          ...trailerForm,
        },
      };
      const response = await instance.put("safety/edit-f15", data);
      if (response.status === 200) {
        setMessage("La modificación fue exitosa.");
        setStatus("Éxito");
      }
    } catch (error) {
      setMessage(error);
      setStatus("Error");
    } finally {
      setResponseModal(true);
      setSubmitRequest(false);
    }
  };

  return (
    <>
      {currentForm === 1 && (
        <div className="page-mask">
          <CheckInTruckF15
            edit={true}
            nextForm={nextForm}
            backForm={close}
            english={english}
            setTruckForm={setTruckForm}
            truckForm={truckForm}
            inOrOut={report.check_in_dt ? true : false}
          />
        </div>
      )}
      {currentForm === 2 && (
        <div className="page-mask">
          <CheckInTrailerF15
            edit={true}
            backForm={backForm}
            nextForm={nextForm}
            english={english}
            setTrailerForm={setTrailerForm}
            trailerForm={trailerForm}
            sealStatus={report.trailer.seal_number ? true : false}
            inOrOut={report.check_in_dt ? true : false}
          />
        </div>
      )}
      {currentForm === 3 && (
        <div className="page-mask">
          <div className="blank-card active-confirm">
            <h4>{english("buttons.confirm")}</h4>
            <p className="gray mb-4">{english("forms.type.f15.edit.review")}</p>
            {submitRequest ? (
              <Spinner />
            ) : (
              <div className="d-flex gap-2 justify-content-center align-items-center full-cont">
                <button className="change-pwd-btn" onClick={handleSubmit}>
                  {english("buttons.submit")}
                </button>
                <button id="back-btn" onClick={backForm} className="cancel-btn">
                  {english("buttons.back")}
                </button>
              </div>
            )}
          </div>
        </div>
      )}
      {responseModal && (
        <ActionResponse
          message={message}
          status={status}
          close={status === "Éxito" ? () => window.location.reload() : () => setResponseModal(false)}
        />
      )}
    </>
  );
};

export const RowClickF15Modal = ({ report, close, english }) => {
  const [previewModal, setPreviewModal] = useState(false);
  const [editModal, setEditModal] = useState(false);
  return (
    <>
      {editModal && (
        <EditF15
          report={report}
          setEditModal={setEditModal}
          english={english}
        />
      )}
      {previewModal && (
        <PreviewF15 report={report} setPreviewModal={setPreviewModal} />
      )}
      <div className="edit-modal">
        <div>
          <h4 data-testid={"documents"} className="global-h2">
            <div>
              {english("yard-tables.tabs.truck")}: {report.truck.carrier_name}-
              {report.truck.truck_number}{" "}
            </div>
            <div>
              {report.trailer
                ? `${english("yard-tables.tabs.trailer")}: ${
                    report.trailer.trailer_number
                  }`
                : ""}
            </div>
          </h4>
          <div style={{ flexGrow: "1" }}></div>
        </div>
        <div style={{ margin: "auto" }}>
          <button
            className="other-btn gap"
            onClick={() => setPreviewModal(true)}
          >
            {english("page-headers.documents")}
          </button>
          <button className="other-btn" onClick={() => setEditModal(true)}>
            {english("buttons.edit-row")}
          </button>
        </div>
        <div className="btn-cont">
          <button onClick={close} className="close-btn">
            {english("buttons.close")}
          </button>
        </div>
      </div>
    </>
  );
};
